
import CONSTANTS from '../constants'
import { deleteRequest, getRequest, postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'
import { addEventLog } from './EventsLog'



export const getVehilceData = () => (dispatch) => {
    dispatch(addEventLog('', CONSTANTS.GET_VEHILCE_LIST_REQUEST))
    dispatch({ type: CONSTANTS.GET_VEHILCE_LIST_REQUEST })
    let endpoint = `${APICONFIG.getVehicleList}/page/1`
    return getRequest(endpoint).then((res) => {
        dispatch(addEventLog(res, CONSTANTS.GET_VEHILCE_LIST_SUCCESS))
        dispatch({ type: CONSTANTS.GET_VEHILCE_LIST_SUCCESS, data: res })
        localStorage.setItem('vehicle', JSON.stringify(res?.data))
        return res
    }).catch((err) => {
        dispatch(addEventLog(err, CONSTANTS.GET_VEHILCE_LIST_FAILURE))
        dispatch({ type: CONSTANTS.GET_VEHILCE_LIST_FAILURE })
        return err
    })
}

export const postVehilce = (payload) => (dispatch) => {
    let payloadVehicle = {...payload, 'device_type': 'web'}
    payloadVehicle = { 'vehicleList'  : [payloadVehicle]}
    dispatch(addEventLog(payloadVehicle, CONSTANTS.ADD_VEHILCE_REQUEST))
    dispatch({ type: CONSTANTS.ADD_VEHILCE_REQUEST })
    return postRequest(APICONFIG.addVehilceUrl, payloadVehicle).then((res) => {
        let resObject = { ...payloadVehicle, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.ADD_VEHILCE_SUCCESS))
        dispatch({ type: CONSTANTS.ADD_VEHILCE_SUCCESS })
        return res
    }).catch((err) => {
        let errObject = { ...payloadVehicle, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.ADD_VEHILCE_FAILURE))
        dispatch({ type: CONSTANTS.ADD_VEHILCE_FAILURE })
        return err
    })
}

export const EditVehicle = (payload) => (dispatch) => {
    let payloadEditVehicle = {...payload, 'device_type': 'web'}
    // payloadEditVehicle = { 'vehicleList'  : payloadEditVehicle}
    dispatch(addEventLog(payloadEditVehicle, CONSTANTS.EDIT_VEHILCE_REQUEST))
    dispatch({ type: CONSTANTS.EDIT_VEHILCE_REQUEST })
    return postRequest(APICONFIG.updateVehicleUrl, payloadEditVehicle).then((res) => {
        let resObject = { ...payloadEditVehicle, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.EDIT_VEHILCE_SUCCESS))
        dispatch({ type: CONSTANTS.EDIT_VEHILCE_SUCCESS })
        return res
    }).catch((err) => {
        let errObject = { ...payloadEditVehicle, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.EDIT_VEHILCE_FAILURE))
        dispatch({ type: CONSTANTS.EDIT_VEHILCE_FAILURE })
        return err
    })
}

export const deleteVehicle = (id) => (dispatch) => {
    dispatch(addEventLog(id, CONSTANTS.DELETE_VEHILCE_REQUEST))
    dispatch({ type: CONSTANTS.DELETE_VEHILCE_REQUEST })
    let tobject = { id: id }
    return deleteRequest(`${APICONFIG.deleteVehilceUrl}/${id}`).then((res) => {
        let resObject = { ...tobject, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.DELETE_VEHILCE_SUCCESS))
        dispatch({ type: CONSTANTS.DELETE_VEHILCE_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...tobject, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.DELETE_VEHILCE_FAILURE))
        dispatch({ type: CONSTANTS.DELETE_VEHILCE_FAILURE })
        return err
    })
}

// GET VEHICLE Model List
export const getVehicleModelList = () => (dispatch) => {
    dispatch(addEventLog('', CONSTANTS.GET_VEHICLE_MODEL_REQUEST))
    dispatch({ type: CONSTANTS.GET_VEHICLE_MODEL_REQUEST })
    return getRequest(`${APICONFIG.getVehicleModelUrl}`).then((res) => {
        dispatch(addEventLog(res, CONSTANTS.GET_VEHICLE_MODEL_SUCCESS))
        dispatch({ type: CONSTANTS.GET_VEHICLE_MODEL_SUCCESS, data: res.data })
        return res.data
    }).catch((error) => {
        dispatch(addEventLog(error, CONSTANTS.GET_VEHICLE_MODEL_FAILURE))
        dispatch({ type: CONSTANTS.GET_VEHICLE_MODEL_FAILURE })
        return error
    })
}

